import React from 'react';
import { keyframes } from '@mui/system';
import { Box, BoxProps } from '@mui/material';
import { Favorite } from '@mui/icons-material';


const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
`;

interface HeartPulseProps extends BoxProps {
  color?: string;
  size?: number;
}

const HeartPulse: React.FC<HeartPulseProps> = ({
  color = '#F29E4C',
  size = 48,
  ...BoxProps
}) => {
  return (
    <Box
      {...BoxProps}
      sx={{
        animation: `${pulseAnimation} 1.6s ease-in-out infinite`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...BoxProps?.sx,
      }}
    >
      <Favorite
        sx={{
          fontSize: size,
          color: color,
        }}
      />
    </Box>
  );
};

export default HeartPulse;
